export default class CheckCredentialsRequest {
    constructor(public username: string, public password: string) {
    }
}
